import $ from "jquery";
// import videojs from "video.js";
import copyTextToClipboard from "@bd-utils/copyTextToClipboard";
import fb from "@bd-core/firebase";
import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import GameLogic from "@bd-core/game-logic";

export const WaitingRoom = () => {
    const isWaitingRoom = $(".waiting-room-page").length > 0;

    if (!isWaitingRoom) return false;

    const elms = {
        pageWaitingRoom: "#page-waitingroom",
        waitingroom: ".waitingroom",
        waitingroomSubtitle: ".waitingroom__subtitle",
        everyoneReady: ".waitingroom__title .allready",
        waitingEveryone: ".waitingroom__title .stillwaiting",
        readyBtn: ".js-ready-btn",
        cancelBtn: ".js-cancel-btn",
        startBtn: ".js-start-game",
        countdownSecond: ".waitingroom-countdown-timer .second .column.animate",
        countdownSecondNum:
            ".waitingroom-countdown-timer .second .column.animate .num",
        introVideo: "#intro-video",

        playerList: ".js-player-list",
        playerItem: ".js-player-item",
        deletePlayerBtn: ".js-player-item-delete",
        teamName: ".js-team-name",
        gameInfoLeave: ".js-leave-team",

        teamId: ".teamId",
        teamIdCopy: ".js-copy-team-id",
        teamIdValue: ".js-team-id-value",

        gameInfo: ".gameInfo",
        gameInfoBtn: ".gameInfo__btn",

        leaderPopup: ".js-leader-popup",
        openCountdown: ".js-open-countdown",

        playerAmount: ".js-player-amount",
    };

    //----------------------------------------------------------------------- Initialize Firebase
    try {
        fb.initializeGame();
    } catch (e) {
        console.error(e);
    }
    //----------------------------------------------------------------------- End Initialize Firebase
   

    // ------------------------------------------------------------------- WAITING ROOM

    let isLoading = false;
    let isReady = false;
    const textReady = $(elms.readyBtn).data("ready");
    const textCancel = $(elms.readyBtn).data("cancel");

    const onPlayerStateChange = (e, eData) => {
        if (!eData || !eData.data) return;

        //handle ready state
        isReady = eData.data.ready;
        $(elms.gameInfo).toggleClass("is-ready", isReady);
        const newText = isReady ? textCancel : textReady;

        $(elms.readyBtn).find("span").text(newText);
        $(elms.readyBtn).toggleClass("is-ready", isReady);
    };

    bdjs.listen("bd__playerStateChanged", onPlayerStateChange);

    const maybeReadyToStart = (players) => {
        if (Array.isArray(players)) {
            let validPlayers = 0;
            let onlinePlayers = 0;
            let readyState = false;

            players.forEach((player) => {
                if (player.userId) validPlayers++;
                if (player.isOnline) onlinePlayers++;
            });

            // Set the check condition to minim 1 since the leader and facilitator are always online
            if (validPlayers > 1 && onlinePlayers > 1) {
                readyState = true;
            } else {
                readyState = false;
            }

            // Exclude the leader and facilitator
            const totalPlayerCount = players.length - 1;
            $(elms.playerAmount).text(totalPlayerCount);

            $(elms.startBtn).prop("disabled", !readyState);
        }
    };

    const onPlayersStateChanged = (e, eData) => {
        /* Update players DOM */
        const players = eData?.data;

        maybeReadyToStart(players);
    };

    bdjs.listen("bd__playersStateChanged", onPlayersStateChanged);

    // On Team Data Changed
    // ------------------------------------------------------------------------
    const maybeTeamNameChanged = (teamData) => {
        if (
            $(elms.pageWaitingRoom).hasClass("is-leader") ||
            !teamData?.teamname
        )
            return;

        $(elms.teamName).val(teamData?.teamname);
    };

    const maybeTeamLeaderChanged = (teamData) => {
        const leaderId = teamData?.leader;

        if (!leaderId) return;

        const $elLeader = $(
            elms.playerItem.concat(`[player-id="${leaderId}"]`),
        );
        const leaderText = $(elms.playerList).attr("data-leader-text");
        const htmlLeader = `<div class="gamePlayer__teamLeader">${leaderText}</div>`;

        $elLeader.find(".js-leader-text").html(htmlLeader);

        if (leaderId == CONFIG.user.id && !CONFIG.game.is_leader) {
            CONFIG.game.is_leader = true;
            $(elms.leaderPopup).addClass("is-open");
            $(elms.pageWaitingRoom)
                .removeClass("is-member")
                .addClass("is-leader");
            $(elms.teamName).removeAttr("readonly");
            $elLeader.find(elms.deletePlayerBtn).addClass("hidden");
        }
    };

    let alreadyStarted = false;
    const maybeStartTheGame = (teamData) => {
        if (!teamData?.isStarting || alreadyStarted) return;

        // let countdownIndex = 1;
        let countdownInterval;

        alreadyStarted = true;

        const startTheGame = async () => {
            bdjs.showLoading();
            const [res] = await bdjs.goAsync(bdapi.post("game/start-game"));

            const restData = res?.data || {};
         
            setTimeout(() => {
                if (restData?.data?.redirect) {
                    window.location.href = restData.data.redirect;
                }
            }, GameLogic.transisitonDuration);
        };


        const stopInterval = () => {
            clearInterval(countdownInterval);

            startTheGame();
        };

        const startCountdown = () => {
            const $countDownTxt = $(".js-time-countdown");
            // const $countDownSecondNum = $(".countdown__num");
            let countdownTotal =  5; //$countDownSecondNum.length;
            // const outerHeight = $countDownSecondNum.outerHeight(true);

            countdownInterval = setInterval(() => {
                // if (countdownIndex === countdownTotal - 2) {
                //     return stopInterval();
                // }

                // const newTranslate = 0 - countdownIndex * outerHeight;

                // if (countdownIndex === 1) {
                //     $(".countdown__column.zero").css({
                //         transform: "translateY(" + newTranslate + "px)",
                //     });
                // }

                // $(".countdown__column.animate").css({
                //     transform: "translateY(" + newTranslate + "px)",
                // });
                // countdownIndex++;

                if(countdownTotal <= 0) {
                    return stopInterval();
                }

                $countDownTxt.text(countdownTotal);
                countdownTotal--;
            }, 1000);
        };

        $(elms.pageWaitingRoom).addClass("is-countdown");
        $("#page-waiting-phone").addClass("is-countdown");
        startCountdown();
    };

    const onTeamStateChanged = (e, eData) => {
        const teamData = eData?.data;

        maybeTeamNameChanged(teamData);
        maybeTeamLeaderChanged(teamData);
        maybeStartTheGame(teamData);
    };

    bdjs.listen("bd__teamAttributeChanged", onTeamStateChanged);

    // Setup Team state on first load
    // ------------------------------------------------------------------------
    const setTeamInitialState = (e, eData) => {
        const teamData = eData?.data;
        $(elms.teamName).val(teamData?.attributes?.teamname || "");
    };

    bdjs.listen("bd__teamInitialState", setTeamInitialState);

    // Copy team id
    // ------------------------------------------------------------------------
    const onCopyTeamId = () => {
        const teamID = String($(elms.teamIdValue).val());
        const isCopied = copyTextToClipboard(teamID);
        if (!isCopied) return false;

        $(elms.teamId).addClass("is-copied");
        setTimeout(() => $(elms.teamId).removeClass("is-copied"), 1000);
    };

    // set team name on input
    // ------------------------------------------------------------------------\

    let timeToWait = 2; //seconds

    /**
     * @type {ReturnType<typeof setInterval> | undefined}
     */
    let intervalUpdate = undefined;

    $(document).on("input", elms.teamName, function () {
        const value = $(this).val();

        clearInterval(intervalUpdate);
        timeToWait = 2;
        intervalUpdate = setInterval(() => {
            timeToWait--;

            if (timeToWait <= 0) {
                clearInterval(intervalUpdate);

                fb.update(fb.teamAttributesPath, {
                    teamname: String(value).trim(),
                });
            }
        }, 1000);
    });


    // Onboarding Box
    // ------------------------------------------------------------------------
    // let isLoading = false;
    const onToggleReady = () => {
        fb.update(fb.currentPlayerPath, {
            ready: !isReady,
        });
    };

    // Countdown button start the game
    // ------------------------------------------------------------------------
    $(document).on("click", elms.startBtn, (e) => {
        e.preventDefault();
        fb.update(fb.teamAttributesPath, { isStarting: true });
        $(elms.startBtn).hide();
    });

    // Leave Game
    // ------------------------------------------------------------------------
    const onLeaveTeam = async (e) => {
        e.preventDefault();

        if (isLoading) return false;
        const message = $(".leave-team").text();
        const confirm_result = confirm(message);

        if (!confirm_result) {
            return false;
        }

        const $this = $(e.currentTarget);

        $this.addClass("is-loading");
        isLoading = true;

        await bdjs.goAsync(bdapi.post("member/leave-team"));
        window.location.reload();
        return false;
    };

    // Leader Popup
    // ------------------------------------------------------------------------

    const closeLeaderPopup = function (e) {
        e.preventDefault();
        const $this = $(this);
        $this.parents(elms.leaderPopup).removeClass("is-open");
    };

    const onOpenCountdown = function (e) {
        e.preventDefault();
        $(elms.pageWaitingRoom).addClass("is-countdown");
    };

    $(elms.leaderPopup)
        .find(".js-completionPopup-close")
        .on("click", closeLeaderPopup);

    $(document).on("click", elms.teamIdCopy, onCopyTeamId);
    $(document).on("click", elms.readyBtn, onToggleReady);
    $(document).on("click", elms.cancelBtn, onToggleReady);
    $(document).on("click", elms.gameInfoLeave, onLeaveTeam);
    $(document).on("click", elms.openCountdown, onOpenCountdown);
    GameLogic.listenGameProgressChanged();
};
